module.exports = __webpack_public_path__ + "images/emoji/mega.4ead47c09a552bf2a057.png";